var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.582 7.2a.6.6 0 0 1 0-1.2h4.37a.6.6 0 0 1-.001 1.2h-4.37zm0 2a.6.6 0 0 1 0-1.2h4.37a.6.6 0 0 1-.001 1.2h-4.37zm0 2a.6.6 0 0 1 0-1.2h4.37a.6.6 0 0 1-.001 1.2h-4.37zm8.964 0a2.595 2.595 0 0 1-2.59-2.6c0-1.436 1.16-2.6 2.59-2.6s2.59 1.164 2.59 2.6c0 1.436-1.16 2.6-2.59 2.6zm0-1.2c.77 0 1.395-.627 1.395-1.4 0-.773-.625-1.4-1.395-1.4s-1.394.627-1.394 1.4c0 .773.624 1.4 1.394 1.4zM4.98 0h8.166c.513 0 1.006.199 1.376.554l6.862 6.587a2.004 2.004 0 0 1-.017 2.907l-6.848 6.414a1.99 1.99 0 0 1-1.36.538H4.98C2.23 17 0 14.761 0 12V5c0-2.761 2.23-5 4.98-5zm0 1.2A3.793 3.793 0 0 0 1.195 5v7c0 2.099 1.695 3.8 3.785 3.8h8.18a.793.793 0 0 0 .543-.215l6.848-6.414a.801.801 0 0 0 .008-1.162l-6.863-6.587a.79.79 0 0 0-.55-.222H4.98z"
  })));
};

export default SvgTag;